const API = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:8000';

export interface PublicSettingsPayload {
  car_listing_price_filter_min?: string | number;
  car_listing_price_filter_max?: string | number;
  car_listing_price_filter_step?: string | number;
  default_country?: string;
  default_currency?: string;
}

export interface CarPriceFilterConfig {
  min: number;
  max: number;
  step: number;
}

export const DEFAULT_CAR_PRICE_FILTER_CONFIG: CarPriceFilterConfig = {
  min: 0,
  max: 500000,
  step: 5000,
};

function toSafeNumber(value: unknown, fallback: number): number {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
}

export function getCarPriceFilterConfig(
  payload?: PublicSettingsPayload | null,
): CarPriceFilterConfig {
  const min = Math.max(0, toSafeNumber(payload?.car_listing_price_filter_min, DEFAULT_CAR_PRICE_FILTER_CONFIG.min));
  const max = Math.max(min, toSafeNumber(payload?.car_listing_price_filter_max, DEFAULT_CAR_PRICE_FILTER_CONFIG.max));
  const step = Math.max(1, toSafeNumber(payload?.car_listing_price_filter_step, DEFAULT_CAR_PRICE_FILTER_CONFIG.step));
  return { min, max, step };
}

export async function fetchPublicSettings(countryCode?: string): Promise<PublicSettingsPayload | null> {
  try {
    const params = new URLSearchParams();
    if (countryCode) {
      params.set('country_code', countryCode);
    }
    const res = await fetch(`${API}/api/settings/public/${params.toString() ? `?${params.toString()}` : ''}`, {
      cache: 'no-store',
      headers: { Accept: 'application/json' },
    });
    if (!res.ok) return null;
    const payload = await res.json();
    return payload && typeof payload === 'object' ? payload : null;
  } catch {
    return null;
  }
}
